<!-- 防疫信息登记 -->
<template>
  <div class="main-window-l">
    <div class="step-nav">
      <div class="nav-item active">
        <span class="sort">1</span>防疫信息填写
      </div>
      <span :class="['split-line', {'active': second || thir}]"></span>
      <div :class="['nav-item', {'active': second || thir}]">
        <span class="sort">2</span>防疫信息确认
      </div>
      <span :class="['split-line', {'active': thir}]"></span>
      <div :class="['nav-item', {'active': thir}]">
        <span class="sort">3</span>完成
      </div>
    </div>

    <div class="inviteCenter ipts" v-if="fir">
      <div class="title">基本信息</div>
      <div class="list">
        <div class="centerItem">
          <label class="name">姓名</label>
          <label class="look">{{ basicData.guestName }}</label>
        </div>
        <div class="centerItem">
          <label class="name">艺名</label>
          <label class="look">{{ basicData.artName }}</label>
        </div>
        <div class="centerItem">
          <label class="name">证件号码</label>
          <label class="look">{{ basicData.certNo }}</label>
        </div>
        <div class="centerItem">
          <label class="name">手机号</label>
          <label class="look">{{ basicData.mobile }}</label>
        </div>
      </div>

      <div class="title">其他信息（*项为必填项）</div>
      <div class="list">
        <div class="centerItem">
          <label class="name">本人手机号*</label>
          <input
            id="myMobile"
            placeholder="请输入本人手机号"
            class="txtin inputRequired"
            v-model="formData.myMobile"
            autocomplete="off"
          />
        </div>
        <div id="reachXmDate" class="centerItem">
          <label class="name">赴厦日期*</label>
          <el-date-picker
            v-model="formData.reachXmDate"
            class="set-el"
            type="date"
            placeholder="赴厦日期"
            value-format="timestamp"
            prefix-icon="none"
            :clearable="false"
          >
          </el-date-picker>
        </div>
        <div id="leaveCity" class="centerItem">
          <label class="name">出发城市*</label>
          <el-cascader
            v-model="formData.leaveCity"
            class="set-el set-el-cascader"
            :options="cityOptions"
            :props="{
              value: 'code',
              label: 'name',
            }"
            placeholder="请选择出发城市"
          ></el-cascader>
        </div>
        <div id="leaveXmDate" class="centerItem">
          <label class="name">离厦日期*</label>
          <el-date-picker
            v-model="formData.leaveXmDate"
            class="set-el"
            type="date"
            placeholder="离厦日期"
            value-format="timestamp"
            prefix-icon="none"
            :clearable="false"
          >
          </el-date-picker>
        </div>
        <div id="reachCity" class="centerItem">
          <label class="name">前往城市*</label>
          <el-cascader
            v-model="formData.reachCity"
            class="set-el set-el-cascader"
            :options="cityOptions"
            :props="{
              value: 'code',
              label: 'name',
            }"
            placeholder="请选择前往城市"
          ></el-cascader>
        </div>
        <div class="centerItem">
          <label class="name">赴厦前两天<br />核酸图片</label>
          <upload-img
            :imgIds="fileIds"
            :imgType="'long'"
            :limitSize="10 * 1024"
            multiple
            @getUploadImg="getUploadImg"
            @delImg="delImg"
          ></upload-img>
        </div>
        <div class="centerItem">
          <label class="name">其他手机号</label>
          <input
            placeholder="请输入本人其他手机号"
            class="txtin"
            v-model="formData.otherMobile"
            autocomplete="off"
          />
        </div>
        <div class="centerItem">
          <div class="d-flex align-c">
            <label class="name">离厦交通方式</label>
            <div class="radio-box">
              <label v-for="(item, index) in trafficTypeOp" :key="index">
                <input
                  v-model="formData.leaveTrafficType"
                  :value="item.val"
                  class="radio_dot"
                  type="radio"
                  name="trafficTypeRadio"
                  @click="handleRadio($event, item)"
                />{{ item.label }}</label>
            </div>
          </div>
        </div>
        <div class="centerItem">
          <label class="name">班次/车牌</label>
          <input
            placeholder="请输入班次号/车牌号"
            class="txtin"
            v-model="formData.leaveTrafficNo"
            autocomplete="off"
          />
        </div>
        <div class="centerItem">
          <label class="name">家庭住址</label>
          <input
            placeholder="请输入家庭住址（具体到门牌号）"
            class="txtin2"
            v-model="formData.homeAddress"
            autocomplete="off"
          />
        </div>
        <div class="centerItem">
          <label class="name">具体抵京时间</label>
          <el-date-picker
            v-model="formData.reachBjDate"
            class="set-el"
            type="datetime"
            placeholder="具体抵京时间"
            value-format="timestamp"
            prefix-icon="none"
            :clearable="true"
          >
          </el-date-picker>
        </div>
        <div class="centerItem">
          <label class="name">闭环转运车号</label>
          <input
            placeholder="请输入闭环转运车号"
            class="txtin"
            v-model="formData.closedTransportNo"
            autocomplete="off"
          />
        </div>
        <div class="centerItem">
          <label class="name">抵京前7天行程</label>
          <input
            placeholder="请输入抵京前7天行程（具体到市县区，直辖市为街乡）"
            class="txtin2"
            v-model="formData.reachBjTrip"
            autocomplete="off"
          />
        </div>
        <div class="centerItem">
          <label class="name">备注</label>
          <input
            placeholder="请输入备注"
            class="txtin2"
            v-model="formData.remark"
            autocomplete="off"
          />
        </div>
      </div>
    </div>

    <div class="inviteCenter" v-if="second">
      <div class="title">基本信息</div>
      <div class="list">
        <div class="centerItem">
          <label class="name">姓名</label>
          <label class="look">{{ basicData.guestName }}</label>
        </div>
        <div class="centerItem">
          <label class="name">艺名</label>
          <label class="look">{{ basicData.artName }}</label>
        </div>
        <div class="centerItem">
          <label class="name">证件号码</label>
          <label class="look">{{ basicData.certNo }}</label>
        </div>
        <div class="centerItem">
          <label class="name">手机号</label>
          <label class="look">{{ basicData.mobile }}</label>
        </div>
      </div>

      <div class="title">其他信息（*项为必填项）</div>
      <div class="list">
        <div class="centerItem">
          <label class="name">本人手机号*</label>
          <label class="look">{{ formData.myMobile }}</label>
        </div>
        <div class="centerItem">
          <label class="name">赴厦日期*</label>
          <label class="look">{{ formData.reachXmDate | timeFilter() }}</label>
        </div>
        <div class="centerItem">
          <label class="name">出发城市*</label>
          <label class="look">{{ formData.leaveCity | cityFilter }}</label>
        </div>
        <div class="centerItem">
          <label class="name">离厦日期*</label>
          <label class="look">{{ formData.leaveXmDate | timeFilter() }}</label>
        </div>
        <div class="centerItem">
          <label class="name">前往城市*</label>
          <label class="look">{{ formData.reachCity | cityFilter }}</label>
        </div>
        <div class="centerItem">
          <label class="name">赴厦前两天<br />核酸图片</label>
          <upload-img
            :verifyFlag="'1'"
            :imgIds="fileIds"
            :imgType="'long'"
            multiple
          ></upload-img>
        </div>
        <div class="centerItem">
          <label class="name">其他手机号</label>
          <label class="look">{{ formData.otherMobile }}</label>
        </div>
        <div class="centerItem">
          <label class="name">离厦交通方式</label>
          <label class="look">{{
            formData.leaveTrafficType | trafficTypeFilter
          }}</label>
        </div>
        <div class="centerItem">
          <label class="name">班次/车牌</label>
          <label class="look">{{ formData.leaveTrafficNo }}</label>
        </div>
        <div class="centerItem">
          <label class="name">家庭住址</label>
          <label class="look">{{ formData.homeAddress }}</label>
        </div>
        <div class="centerItem">
          <label class="name">具体抵京时间</label>
          <label class="look">{{
            formData.reachBjDate | timeFilter("{y}-{m}-{d} {h}:{i}:{s}")
          }}</label>
        </div>
        <div class="centerItem">
          <label class="name">闭环转运车号</label>
          <label class="look">{{ formData.closedTransportNo }}</label>
        </div>
        <div class="centerItem">
          <label class="name">抵京前7天行程</label>
          <label class="look">{{ formData.reachBjTrip }}</label>
        </div>
        <div class="centerItem">
          <label class="name">备注</label>
          <label class="look">{{ formData.remark }}</label>
        </div>
      </div>
    </div>

    <div class="content" v-if="thir">
      <div class="suc-remind">
        <img src="@/static/img/jj_gou.png" />
        <p>防疫信息已提交</p>
        <p style="font-size: 16px">
          <span>{{ jumpT }}</span
          >s跳转到个人中心…
        </p>
      </div>
    </div>

    <div v-if="!thir" class="foo">
      <div v-if="fir">
        <button class="leftBtn" @click="pre">返回</button>
        <button class="rightBtn" @click="next">下一步</button>
      </div>
      <div v-if="second">
        <button class="leftBtn" @click="pre">返回修改</button>
        <button class="rightBtn" @click="submit">确认提交</button>
      </div>
    </div>
  </div>
</template>

<script>
import cityJson from "@/static/city.json";
import UploadImg from "../components/UploadImg";
import { sessionData } from "@/static/js/local.js";
import { antiepidemic } from "@/api/antiepidemic";

var that;

export default {
  components: { UploadImg },
  filters: {
    cityFilter(codeArr) {
      let arr = [];
      let judgeArr1 = [],
        judgeArr2 = [];
      codeArr.forEach((item, index) => {
        switch (index) {
          case 0:
            for (let i = 0; i < that.cityOptions.length; i++) {
              if (that.cityOptions[i].code === item) {
                judgeArr1 = [].concat(that.cityOptions[i].children);
                arr[index] = that.cityOptions[i].name;
              }
            }
            break;
          case 1:
            for (let i = 0; i < judgeArr1.length; i++) {
              if (judgeArr1[i].code === item) {
                judgeArr2 = [].concat(judgeArr1[i].children);
                arr[index] = judgeArr1[i].name;
              }
            }
            break;
          case 2:
            for (let i = 0; i < judgeArr2.length; i++) {
              if (judgeArr2[i].code === item) {
                arr[index] = judgeArr2[i].name;
              }
            }
            break;
        }
      });
      return arr?.length ? arr.join("/") : "";
    },
    trafficTypeFilter(val) {
      if (val) {
        const obj = that.trafficTypeOp.find((item) => item.val == val);
        return obj.label || val;
      }
      return val;
    },
    timeFilter: function(tsp, type) {
      try {
        if (!tsp || tsp.toString().length == 0) {
          return "";
        }

        return that.$parseTime(tsp, type || "{y}-{m}-{d}");
      } catch (err) {
        return "";
      }
    },
  },
  data() {
    return {
      jumpT: 3,
      trafficTypeOp: [
        {
          label: "火车/动车",
          val: "1",
        },
        {
          label: "飞机",
          val: "2",
        },
        {
          label: "自驾",
          val: "3",
        },
      ],
      limitArr: [
        "工作人员（厦门数字）",
        "系列活动（大型活动部）",
        "系列活动（国内影展部）",
        "系列活动（论坛部）",
        "系列活动（提名表彰部）",
        "系列活动（办公室）",
        "工作人员（光影彩墨）",
        "光影彩墨嘉宾（系列活动）",
      ],
      basicData: {},
      formData: {
        guestId: "",
        guestName: "",
        inviteCode: "",
        orgFlag: 1, //表单填写来源，默认前台
        myMobile: "",
        reachXmDate: null,
        leaveCity: "",
        leaveXmDate: null,
        reachCity: "",
        preventionImg: "", // 核酸图片
        otherMobile: "",
        leaveTrafficType: "",
        leaveTrafficNo: "",
        homeAddress: "",
        reachBjDate: "",
        closedTransportNo: "",
        reachBjTrip: "",
        remark: "",
      },
      fileIds: [],
      fir: true,
      second: false,
      thir: false,
    };
  },
  beforeCreate() {
    that = this;
  },
  created() {
    this.cityOptions = this.$proCityOp();
    this.basicData = sessionData("get", "UserInfo");
    if (this.limitArr.indexOf(this.basicData.guestType) !== -1) {
      this.$msgbox({
        title: "提示",
        message: "无权限访问",
        showClose: false,
        confirmButtonClass: "btn-color",
        closeOnClickModal: false,
        closeOnPressEscape: false,
        callback: (action, instance) => {
          if (action == "confirm") {
            this.$router.push("/userIndex");
          }
        },
      });
    }
    this.formData.inviteCode = sessionData("get", "inviteCode");
    if (this.basicData.id) {
      this.formData.guestId = this.basicData.id;
      this.formData.guestName = this.basicData.guestName;
      this.formData.myMobile = this.basicData.mobile;
    }
    this.getDetail();
  },
  methods: {
    async getDetail() {
      const loading = this.$Loading.service({
        text: "",
        customClass: "custom-loading",
      });
      try {
        const res = await antiepidemic.getDetail();
        if (res.code === 200 && res.data && res.data.id) {
          this.formData = {
            ...res.data,
            leaveCity: res.data.leaveCity.split("-"),
            reachCity: res.data.reachCity.split("-"),
          };
          if (this.formData.preventionImg) {
            this.fileIds = this.formData.preventionImg.split(";");
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        loading.close();
      }
    },
    // 上传照片
    getUploadImg(id) {
      this.fileIds.push(id);
    },
    // 删除照片
    delImg(id) {
      let findIndex = this.fileIds.findIndex((item) => item === id);
      if (findIndex !== -1) {
        this.fileIds.splice(findIndex, 1);
      }
    },
    handleRadio(e, obj) {
      if (e.target.checked && this.formData.leaveTrafficType === obj.val) {
        this.formData.leaveTrafficType = "";
      }
    },
    pre() {
      if (this.fir) {
        this.$router.push("/userIndex");
      }
      if (this.second) {
        this.fir = true;
        this.second = false;
      }
    },
    // 下一步
    next() {
      if (!this.checkForm()) {
        return;
      }
      this.fir = false;
      this.second = true;
    },
    async submit() {
      const loading = this.$Loading.service({
        text: "",
        customClass: "custom-loading",
      });
      let params = {
        ...this.formData,
        leaveCity: this.formData.leaveCity.join("-"),
        reachCity: this.formData.reachCity.join("-"),
        preventionImg: this.fileIds.join(";"),
      };
      try {
        let res = null;
        if (this.formData.id) {
          res = await antiepidemic.update(params);
        } else {
          res = await antiepidemic.add({
            mainId: this.$session.get("cmm").mainId,
            ...params,
          });
        }
        if (res.code == 200) {
          this.second = false;
          this.thir = true;
          setInterval(() => {
            this.jumpT--;
            if (this.jumpT == 0) {
              this.$router.push("/userIndex");
            }
          }, 1000);
        }
      } catch (error) {
        console.log(error);
      } finally {
        loading.close();
      }
    },
    // 表单校验
    checkForm: function() {
      var data = $(".ipts").serialize();
      var array = data.split("&");
      for (var i = 0; i < array.length; i++) {
        var arr = array[i].split("=");
        var len = $(".inputRequired").length;
        for (var j = 0; j < len; j++) {
          const value = $(".inputRequired")
            .eq(j)
            .val();
          if (value == null || value == "") {
            this.$message("该项不能为空~");
            $(".inputRequired")
              .eq(j)
              .focus();
            return false;
          }
        }
      }

      if (!this.$isPhone(this.formData.myMobile)) {
        this.$message("请输入正确的手机号");
        $("#myMobile").focus();
        return;
      }

      const scrollElements = new Map([
        ['reachXmDate', '请选择赴厦日期'],
        ['leaveCity', '请选择出发城市'],
        ['leaveXmDate', '请选择离厦日期'],
        ['reachCity', '请选择前往城市']
      ])

      for (let key of scrollElements) {
        if (!this.formData[key[0]]) {
          document.getElementById(key[0]).scrollIntoView();
          this.$message(key[1]);
          return false;
        }
      }

      if (this.formData.reachXmDate > this.formData.leaveXmDate) {
        this.$message("离厦时间不能早于赴厦时间");
        return false;
      }

      return true;
    },
  },
};
</script>

<style src="../../static/css/regist.css" scoped></style>
<style scoped>
.name {
  width: 130px;
}
.set-el-cascader {
  width: 725px !important;
}
.img-box {
  width: calc(100% - 130px);
}
</style>

<style>
.set-el-cascader .el-input {
  font-size: 16px !important;
}
</style>
